import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { error } from 'selenium-webdriver';
import { Gestor } from 'src/app/models/gestor.model';
import { GestoresService } from 'src/app/services/gestores.service';
import { LoginService } from 'src/app/services/login-participante.service';
import { MessageService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssistenteDTO } from 'src/app/models/assistenteDTO.model';

@Component({
  selector: 'app-cadastro-assistente',
  templateUrl: './cadastro-assistente.component.html',
  styleUrls: ['./cadastro-assistente.component.css']
})
export class CadastroAssistenteComponent implements OnInit {
  resposta: any;
  formGroup: FormGroup;
  assistente = new AssistenteDTO();
  token: string;
  senha: string;
  confirmacaoSenha:string;
  idGestor: number;

  constructor(
    private spinner: NgxSpinnerService,
    protected gestores: GestoresService,
    protected messageService: MessageService,
    ) { }

  ngOnInit() {
    this.token = sessionStorage.getItem('token');

    this.formGroup = new FormGroup({
      nome: new FormControl(),
      cpf: new FormControl(),
      email: new FormControl(),
      senha: new FormControl(),
      confirmacaoSenha: new FormControl()
    })
  }
  salvarNovoGestor(){
    
  }

  public onSubmit(value){

    let email = this.formGroup.get('email').value
    let senha = this.formGroup.get('senha').value
    let confirmacaoSenha = this.formGroup.get('confirmacaoSenha').value
    let nome = this.formGroup.get('nome').value
    let cpf = this.formGroup.get('cpf').value
    let token = sessionStorage.getItem('token');
    let idGestor = sessionStorage.getItem('idGestor');
    
    if(senha == confirmacaoSenha){

      this.assistente.login = email
      this.assistente.senha = senha
      this.assistente.nome = nome
      this.assistente.cpf = cpf
      this.token = token
      this.idGestor = Number(idGestor)
      this.assistente.gestor = {id:this.idGestor}
      

      this.gestores.salvarNovoAssistente(this.token,this.assistente).then((data: AssistenteDTO) => {
        this.resposta = data;
        console.log("resposta",JSON.stringify(this.resposta))
        console.log("dados assistente",this.assistente)
        console.log("TOKEN",this.token)
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "O assistente foi cadastrado com sucesso!" });
        window.history.back();

      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error",error)
      });
    }else{
      alert("As senhas não conferem! Por favor, corrija.")
    }
  }
  public goBack(){
    //Impede o submit nessa função
    event.preventDefault();
    //============================

    window.history.back();
  }
}
